import { LineChartOutlined, MinusOutlined } from '@ant-design/icons';
import ParentSize from '@visx/responsive/lib/components/ParentSize';
import { Button, Card, Col, Row, Spin, Tooltip, Typography } from 'antd';
import React, { useState } from 'react';
import { useCookies } from 'react-cookie';
import UsageChart from './UsageChart';
import { GabiiErrorsPerDay, GabiiUsagePerDay } from '../../../models/gabii-statistics-interface';

const { Title } = Typography;

interface UsageCardProps {
  data: GabiiUsagePerDay[] | undefined;
  errorData: GabiiErrorsPerDay[] | undefined;
  pageIsLoading: boolean;
  chartIsLoading: boolean;
}

enum UsageChartSetting {
  Hidden = 0,
  Visible = 1,
}

const activityChartCookie = 'hideShowActivityChart';

export default function UsageChartCard({
  data,
  errorData,
  pageIsLoading,
  chartIsLoading
}: UsageCardProps) {
  const [cookies, setCookie] = useCookies(['sessionUserName']);
  const [chartSetting, setChartSetting] = useState<UsageChartSetting>(
    cookies[activityChartCookie] !== undefined
      ? parseInt(cookies[activityChartCookie]) : UsageChartSetting.Visible
  );

  const updateChartSetting = () => {
    if (chartSetting === UsageChartSetting.Hidden) {
      setChartSetting(UsageChartSetting.Visible);
      setCookie(activityChartCookie, UsageChartSetting.Visible, {path: "/"});
    } else {
      setChartSetting(UsageChartSetting.Hidden);
      setCookie(activityChartCookie, UsageChartSetting.Hidden, {path: "/"});
    }
  };

  const hasActivity = !!data && !!errorData ? data.filter(x => x.userMessageCount > 0).length > 0 || errorData.filter(x => x.errorCount > 0).length > 0 : false

  return (
    <>
      <Tooltip
        overlay={
          chartSetting === UsageChartSetting.Hidden
            ? 'Show usage chart'
            : 'Hide usage chart'
        }
      >
        <Button
          type='primary'
          shape='circle'
          icon={
            chartSetting === UsageChartSetting.Hidden ? (
              <LineChartOutlined />
            ) : (
              <MinusOutlined />
            )
          }
          onClick={() => updateChartSetting()}
          style={{
            marginBottom: -50,
            zIndex: 100,
            position: 'absolute',
            top: -14,
            right: 25,
          }}
        />
      </Tooltip>
      {chartSetting !== UsageChartSetting.Hidden && (
        <Card
          style={hasActivity ? {
            height: 380,
            borderWidth: 1,
          } : {}}
        >
          <Title level={5}>Usage/Errors</Title>
          <Spin
            spinning={
              chartIsLoading && chartSetting === UsageChartSetting.Visible
            }
          >
              {!!data && !!errorData && hasActivity ? 
              <div
              style={{
                height: 360,
              }}
            >
              <ParentSize>
                {({ width, height }) => (
                  <UsageChart
                    height={height}
                    width={width}
                    data={data}
                    errorData={errorData}
                    isLoading={pageIsLoading || chartIsLoading}
                  />
                )}
              </ParentSize>
            </div>
              : !!data && !!errorData ? <Row align='middle' justify='center'><Col span={24}><LineChartOutlined /> No activity found</Col></Row> : null }
          </Spin>
        </Card>
      )}
    </>
  );
}
